// extracted by mini-css-extract-plugin
module.exports = {"container":"ClientStatusBadge_container__KZZiG","closedBadge":"ClientStatusBadge_closedBadge__q4gP3","activeBadge":"ClientStatusBadge_activeBadge__1EAjK"};